import { SearchConfig } from '@/components/page-model/typing';
import { reactive } from 'vue';
import { RuleObject } from 'ant-design-vue/lib/form/interface';
import moment from 'moment';
import { config } from '@/components/page-model/log_app/log_app-logsubject-config';

export default (current_org: any) => {
  const None = null;
  const True = true;
  const False = false;

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'vertical',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const edit_model_config_options = {};

  return {
    edit_model_config: edit_model_config,
    edit_model_config_options: edit_model_config_options,
  };
};
